/* Only native pages intersecting the current global available/sold-out page. */
if (!customElements.get('sf-collection-order')) {
  customElements.define('sf-collection-order', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      queueMicrotask(() => { if (this.isConnected) this.reorder(); });
    }
    disconnectedCallback() { this.controller.abort(); }
    async reorder() {
      const available = Number(this.dataset.available);
      const unavailable = Number(this.dataset.unavailable);
      const perPage = Number(this.dataset.perPage);
      const page = Number(this.dataset.page);
      if (this.dataset.filtered !== 'false' || new URLSearchParams(location.search).has('filter.v.availability') || !available || !unavailable || !perPage) return;
      const start = (page - 1) * perPage;
      const end = Math.min(start + perPage, available + unavailable);
      const jobs = [];
      for (const group of [{ value: '1', offset: 0, count: available }, { value: '0', offset: available, count: unavailable }]) {
        const localStart = Math.max(0, start - group.offset);
        const localEnd = Math.min(group.count, end - group.offset);
        if (localEnd <= localStart) continue;
        for (let nativePage = Math.floor(localStart / perPage) + 1; nativePage <= Math.ceil(localEnd / perPage); nativePage++) {
          jobs.push({ value: group.value, page: nativePage,
            from: Math.max(0, localStart - (nativePage - 1) * perPage),
            to: Math.min(perPage, localEnd - (nativePage - 1) * perPage) });
        }
      }
      if (jobs.length > 3) return;
      const grid = this.parentElement.querySelector('ul#product-grid');
      if (!grid) return;
      try {
        const groups = await Promise.all(jobs.map(async job => {
          const url = new URL(location.href);
          url.searchParams.set('section_id', this.dataset.section);
          url.searchParams.set('filter.v.availability', job.value);
          url.searchParams.set('page', job.page);
          const response = await fetch(url, { signal: this.controller.signal });
          if (!response.ok) throw new Error('Collection response failed');
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const source = parsed.querySelector('ul#product-grid');
          if (!source) throw new Error('Missing grid');
          const items = Array.from(source.children).slice(job.from, job.to);
          if (items.length !== job.to - job.from) throw new Error('Incomplete collection page');
          return items;
        }));
        if (!this.isConnected || this.controller.signal.aborted) return;
        const items = groups.flat();
        if (items.length !== end - start) return;
        items.forEach((item, index) => {
          item.classList.add('scroll-trigger--cancel');
          item.style.setProperty('--animation-order', index + 1);
        });
        grid.replaceChildren(...items);
        this.dataset.ordered = 'true';
      } catch (error) {
        // Keep the usable original native page on abort/network mismatch.
        if (error.name !== 'AbortError') this.dataset.ordered = 'fallback';
      }
    }
  });
}
if (!customElements.get('sf-brand-filter')) {
  customElements.define('sf-brand-filter', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.querySelector('form')?.addEventListener('submit', event => {
        event.preventDefault();
        const vendor = this.querySelector('select').value;
        const url = new URL(location.href);
        const base = this.querySelector('form').getAttribute('action');
        url.pathname = vendor ? base : base.replace(/\/vendors$/, '/all');
        url.searchParams.delete('page');
        url.searchParams.delete('section_id');
        url.searchParams.delete('q');
        if (vendor) url.searchParams.set('q', vendor);
        location.assign(url.href);
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller.abort(); }
  });
}
